import { useEffect, useState } from "react";
import {
  SmartAlert,
  SmartLoaderInterface,
  SmartSoftButton,
  SmartTable,
  SmartTableNewInterface,
} from "sds_react_toolkit";
import { HOLIDAYS_URLS, COMPANY_URLS } from "../../api/ManageUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showAlertAutoClose } from "../../services/notifyService";
import { get, post } from "../../services/smartApiService";

import HolidaysForm from "./HolidaysForm";

const HolidaysTable = () => {
  const [tabData, setTabData] = useState<any[]>([]);

  const { openModal, setTitle } = useSiteContext();

 

  useEffect(() => {
    loadTableData();
    setTitle("Manage Holidays");
  }, []);

  const loadTableData = () => {
    const URL = HOLIDAYS_URLS.GET_ALL

    const subscription = get(URL).subscribe((response) => {
      setTabData(response.data || []);
    });
    return () => subscription.unsubscribe();
  };

  const deleteData = (id: number) => {
    const subscription = post(`${HOLIDAYS_URLS.DELETE}${id}`, {}).subscribe(() => {
      showAlertAutoClose("Holiday removed successfully", "success");
      loadTableData();
    });
    return () => subscription.unsubscribe();
  };

  const openDeleteModal = (row: any) => {
    const alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: (
        <span className="has-text-danger">
          <i className="fa fa-exclamation-triangle"></i> Confirm Removal
        </span>
      ),
      alertFunction: (option: any) => {
        if (option === "yes") {
          deleteData(row.id);
          SmartAlert.hide();
        }
      },
      content: (
        <p>
          Do you want to remove <strong>{row.company_name}</strong> from{" "}
          <strong>{row.index_name}</strong>? <br />
          <strong>This action cannot be undone.</strong>
        </p>
      ),
      className: "custom-alert",
    };
    SmartAlert.show(alertProps);
  };

  const openIndexCompanyForm = (data?: any) => {
    const options = {
      title: "Add Holiday",
      content: (
        <HolidaysForm
          loadTableData={loadTableData}
          data={data}
        />
      ),
      className: "sd-efl-modal",
      closeBody: false,
      width: 80,
    };
    openModal(options);
  };
const viewEditForm = (id: number) => {
    const subscription = get(`${HOLIDAYS_URLS.GET_ONE}${id}`).subscribe(
      (response: any) => {
        openIndexCompanyForm(response.data);
      }
    );
    return () => subscription.unsubscribe();
  };
  const buttons = [
       {
      label: "",
      type: "icon",
      leftIcon: "fa fa-pencil-square",
      classList: ["smart-hims-table-edit-icon"],
      onClick: (data: any) => viewEditForm(data.id),
    },
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-trash",
      classList: ["smart-hims-table-delete-icon"],
      onClick: (data: any) => openDeleteModal(data),
    },
  ];

 const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
  { title: "S.NO", index: "s_no", type: "sno", width: "5" },

  {
    title: "Holiday Name",
    index: "holiday_name",
    width: "35",
    isSortable: true,
    isFilterable: true,
  },

  {
    title: "Date",
    index: "holiday_date",
    type: "date",
    dateFormat: "DD-MM-YYYY",
    width: "20",
    isSortable: true,
    valueFunction: (row: any) =>
      row.holiday_date ? row.holiday_date : "-",
  },

  {
    title: "Exchange",
    index: "exchange",
    width: "20",
    isSortable: true,
    isFilterable: true,
  },

  {
    title: "Action",
    index: "action",
    type: "buttons",
    buttons,
    width: "10",
  },
];



  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-7",
      custom: <p className="is-size-4 has-text-weight-bold">HOLIDAYS</p>,
    },
  
    {
      type: "SEARCH",
      widthClass: "is-3",
      align: "JUSTIFY",
    },
    {
      type: "BUTTONS",
      widthClass: "is-1",
      align: "RIGHT",
      buttons: [
        {
          type: "REFRESH",
          action: loadTableData,
        },
      ],
    },
    {
      type: "CUSTOM",
      widthClass: "is-1",
      align: "RIGHT",
      custom: (
        <SmartSoftButton
          label="Add"
          onClick={() => openIndexCompanyForm()}
          leftIcon="fa-plus"
          classList={["smart-action-button"]}
        />
      ),
    },
  ];

  return (
    <div className="sd-efl-input">
      <SmartTable
        columns={columns}
        data={tabData}
        tableTop={tableTop}
        tableProps={{
          className: "is-hoverable is-striped dsc-table-container",
          isResponsive: true,
          searchPlaceHolder: "Search HOLIDAYS",
        }}
        paginationProps={{
          pageSize: 10,
        }}
      />
    </div>
  );
};

export default HolidaysTable